import { UserManagement as UserManagementComponent } from "@/components/UserManagement";

export default function UserManagement() {
  return <UserManagementComponent />;
}